import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '../../../finance/expenses/travelrefund/mixins/ExpenseMixin.js'
import { loading } from '@/shared/utils/UIHelper'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm'
import SectionRHRepository from '@/shared/http/repositories/business/sectionrh'
import ExpenseRepository from '@/shared/http/repositories/business/expense'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
import GroupRefundTravelRepository from '@/shared/http/repositories/configuration/grouprefundtravel.js'
export default {
  name: 'SearchTravelAdvance',
  data () {
    return {
      title: 'PESQUISA DE AUTORIZAÇÕES',
      dataSituacao: [],
      dataGrupoSolicitante: [],
      form: {
        obraid: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        responsavelId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        funcionarioId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        secaoRH: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        situacao: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        despesaLog: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        despesaDescontoLote: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        grupoSolicitante: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      allRegional: []
    }
  },
  props: {
    flDespesas: {
      type: Boolean,
      default: false
    }
  },
  components: {AutocompleteZ},
  mixins: [ActionsForm, ExpenseMixin],
  watch: {
    flDespesas (newValue) {
      this.form.despesaLog.value = null
      localStoreHelper.reembolsoViagem.adiantamentoPrestacao(null)
      this.GetEnumSituacao()
    }
  },
  mounted () {
    this.GetEnumSituacao()
    this.GetRegional()
    this.GetGrupoSolicitante()
  },
  methods: {
    Clear () {

    },
    Search () {
      localStoreHelper.reembolsoViagem.adiantamentoPrestacao({
        'obraid': this.form.obraid.value,
        'responsavelId': this.form.responsavelId.value,
        'funcionarioId': this.form.funcionarioId.value,
        'secaoRH': this.form.secaoRH.value,
        'situacao': this.form.situacao.value,
        'despesaLog': this.form.despesaLog.value,
        'despesaDescontoLote': this.form.despesaDescontoLote.value,
        'grupoSolicitante': this.form.grupoSolicitante.value
      })
      this.$emit('search', this.form)
    },
    onClearSection () {
      localStoreHelper.reembolsoViagem.adiantamentoPrestacao(null)
      Object.keys(this.form).forEach((Element) => {
        this.form[Element].value = null
      })
      if (this.flDespesas === true) {
        this.$refs.despesaLog.clear()
      } else {
        this.$refs.termoLoteTypehead.clear()
      }
      this.$refs.obraRHTypeahead.clear()
      this.$refs.responsavelTypeahead.clear()
      this.$refs.favorecidoTypeahead.clear()
      this.$refs.descontoLog.clear()
    },
    onChangeCodeSection () {
    },
    changeByName () {

    },
    GetEnumSituacao () {
      if (!this.flDespesas) {
        loading.push()
        AcceptanceTermRepository.GetEnumSituacao()
          .then(Response => {
            loading.pop()
            this.dataSituacao = Response.data
          })
          .catch(Error => loading.pop())
      } else {
        loading.push()
        ExpenseRepository.GetEnumSituacao()
          .then(Response => {
            this.dataSituacao = Response.data
            loading.pop()
          })
          .catch(Error => loading.pop())
      }
    },
    GetRegional () {
      loading.push()
      SectionRHRepository.GetAll(this.CompanySelected)
        .then(Response => {
          this.allRegional = Response.data.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    GetGrupoSolicitante () {
      GroupRefundTravelRepository.GetAll()
        .then((response) => {
          const dados = response.data.data || []
          this.dataGrupoSolicitante = [
            ...dados.map(g => ({
              value: g.id,
              text: g.nome
            }))
          ]
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/SearchTravelAdvance/SearchTravelAdvance.js